import {
  FETCH_MAKER_CHECKER_LIST,
  FETCH_MAKER_CHECKER_LIST_FAIL,
  FETCH_MAKER_CHECKER_LIST_SUCCESS,
  CHANGE_MAKER_CHECKER_LIST_PAGE,
  CHANGE_MAKER_CHECKER_LIST_PAGE_SIZE,
  RELOAD_MAKER_CHECKER,
  UPDATE_MAKER_CHECKER_LIST_FILTERS,
  FETCH_GENERAL_MAKER_CHECKER_LIST,
  FETCH_GENERAL_MAKER_CHECKER_LIST_SUCCESS,
  FETCH_GENERAL_MAKER_CHECKER_LIST_FAIL,
  UPDATE_MAKER_CHECKER_TYPE
} from '../../actions/cm/makerChecker';
import { DEFAULT_PAGE_SIZE } from '../../../pages/constants/cmConstants';

export const initialState = {
  list: [],
  selectedTab: 'Case',
  generalList: [],
  generalTotal: [],
  isLoading: false,
  hasLoaded: false,
  total: 0,
  hasError: false,
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  filters: {
    searchField: '',
    searchText: ''
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_MAKER_CHECKER_LIST:
    case FETCH_GENERAL_MAKER_CHECKER_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_MAKER_CHECKER_LIST_SUCCESS:
      return {
        ...state,
        list: payload.cases,
        total: payload.total,
        isLoading: false,
        hasLoaded: true
      };
    case FETCH_MAKER_CHECKER_LIST_FAIL:
    case FETCH_GENERAL_MAKER_CHECKER_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    case CHANGE_MAKER_CHECKER_LIST_PAGE:
      return {
        ...state,
        currentPage: payload,
        hasLoaded: false
      };
    case CHANGE_MAKER_CHECKER_LIST_PAGE_SIZE:
      return {
        ...state,
        pageSize: payload,
        hasLoaded: false
      };
    case RELOAD_MAKER_CHECKER:
      return {
        ...state,
        hasLoaded: false
      };
    case UPDATE_MAKER_CHECKER_LIST_FILTERS:
      return {
        ...state,
        filters: payload,
        hasLoaded: false,
        currentPage: 1
      };
    case FETCH_GENERAL_MAKER_CHECKER_LIST_SUCCESS:
      return {
        ...state,
        generalList: payload.items,
        generalTotal: payload.total,
        list: [],
        total: 0,
        isLoading: false,
        hasLoaded: true
      };
    case UPDATE_MAKER_CHECKER_TYPE:
      return {
        ...state,
        selectedTab: payload,
        hasLoaded: false,
        list: [],
        generalList: [],
        generalTotal: [],
        isLoading: false,
        total: 0,
        hasError: false,
        currentPage: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        filters: {
          searchField: '',
          searchText: ''
        }
      };
    default:
      return state;
  }
}
